import __hotels from "./jsons/__hotels.json";
import { DEMO_CATEGORIES } from "./taxonomies";
import { HotelType } from "./types";
import { DEMO_AUTHORS } from "./authors";

// FOR MAIN DEMO
const DEMO_HOTELS = __hotels.map((post): HotelType => {
  //  ##########  GET CATEGORY BY CAT ID ######## //
  return {
    ...post
  }
});

export { DEMO_HOTELS };